/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module AnalyticsModule
 */

import { Component, Input } from '@angular/core';
import { IEndToEndKnot } from 'ng/modules/analytics/types';
import * as globalL10n from 'global-l10n';
import './end-to-end-knot.component.less';

const { ...globalL10nKeys } = globalL10n;

/**
 * @description Single knot used to display end to end card metric. It contains Icon or Value.
 * If icon is present, it will display icon with text, else it will display value with metric
 * values / icons. Draw a bridge when we have hasBridge flag set to true.
 * @author Deepak Chaudhary
 */

@Component({
    selector: 'end-to-end-knot',
    templateUrl: './end-to-end-knot.component.html',
})
export class EndToEndKnotComponent {
    /**
     * End to end config for the single knot.
     */
    @Input()
    public endToEndKnot: IEndToEndKnot;

    @Input()
    public isExpanded: boolean;

    public readonly globalL10nKeys = globalL10nKeys;
}
